import type { FullProfileInfoData } from '../../CustomDash/components/Chart/FullProfileInfo/types';

interface EffectiveSalary {
  userSalary: number;
  salaryTypeLabel: 'Base' | 'TC';
  isSimulated: boolean;
}

/**
 * Derive the effective salary from profile data, with optional override.
 * Centralises the duplicated `min > 0 ? min : max` logic.
 */
export const getEffectiveSalary = (
  profileData: FullProfileInfoData,
  simulatedSalary: number | null
): EffectiveSalary => {
  const usesBase = profileData.metadata.salary.min > 0;
  const originalSalary = usesBase
    ? profileData.metadata.salary.min
    : profileData.metadata.salary.max;
  const salaryTypeLabel = usesBase ? 'Base' : 'TC';

  if (simulatedSalary !== null && simulatedSalary > 0) {
    return { userSalary: simulatedSalary, salaryTypeLabel, isSimulated: true };
  }

  return { userSalary: originalSalary, salaryTypeLabel, isSimulated: false };
};
